import '../../../utils/index.mjs';
import { buildProps } from '../../../utils/vue/props/runtime.mjs';

const popperArrowProps = buildProps({
  arrowOffset: {
    type: Number,
    default: 5
  }
});
const usePopperArrowProps = popperArrowProps;

export { popperArrowProps, usePopperArrowProps };
//# sourceMappingURL=arrow.mjs.map
